<h2 mat-dialog-title>{{ data.title ?? '' }}</h2>
<mat-dialog-content class="mat-typography">
  {{ data.description ?? '' }}
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="false">
    {{ data.cancelLabel ?? ('COMMON.CANCEL' | translate) }}
  </button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>{{ data.confirmLabel ?? ('COMMON.OK' | translate) }}</button>
</mat-dialog-actions>
